import {
  GetCatalogProductViewQuery,
  ProductAvailableSetType,
} from '@notino/shared/definitions/types';

import { messages } from './messages';

export const getDiscoverSetsMessage = (
  sets: NonNullable<
    NonNullable<
      GetCatalogProductViewQuery['productDetailByCatalogMasterId']
    >['features']['availableSets']
  >['sets']
) => {
  let containsUnknown = false;
  let containsGiftSet = false;
  let containsTravelSet = false;
  let containsEconomySet = false;

  sets?.forEach((set) => {
    if (set?.type === ProductAvailableSetType.Unknown) {
      containsUnknown = true;
    }
    if (set?.type === ProductAvailableSetType.GiftSet) {
      containsGiftSet = true;
    }
    if (set?.type === ProductAvailableSetType.TravelSet) {
      containsTravelSet = true;
    }
    if (set?.type === ProductAvailableSetType.EconomyPack) {
      containsEconomySet = true;
    }
  });

  if (containsUnknown) {
    return messages.discoverSets;
  }
  if (containsGiftSet && containsTravelSet && containsEconomySet) {
    return messages.discoverSets;
  }

  if (containsGiftSet && containsEconomySet) {
    return messages.discoverGiftSetsAndEconomySets;
  }
  if (containsTravelSet && containsEconomySet) {
    return messages.discoverTravelSetsAndEconomySets;
  }
  if (containsGiftSet && containsTravelSet) {
    return messages.discoverGiftSetsAndTravelSets;
  }

  if (containsGiftSet) {
    return messages.discoverGiftSets;
  }
  if (containsEconomySet) {
    return messages.discoverEconomySets;
  }
  if (containsTravelSet) {
    return messages.discoverTravelSets;
  }

  return messages.discoverSets;
};
